import Vue from 'vue'
import {
  Alert,
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Col,
  ColorPicker,
  DatePicker,
  Divider,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  MessageBox,
  Notification,
  Option,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Slider,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  TimeSelect,
  Tooltip,
} from 'element-ui'

Vue.use(Alert)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.use(ColorPicker)
Vue.use(DatePicker)
Vue.use(Divider)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Loading)
Vue.use(Option)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Row)
Vue.use(Select)
Vue.use(Slider)
Vue.use(Switch)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(TimeSelect)
Vue.use(Tooltip)

Vue.prototype.$notify = Notification
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$loading = Loading.service
